import { createAsyncThunk } from "@reduxjs/toolkit";
import dashboardApi from "@infrastructure/dashboard-api";
import { getErrorPayload } from "@application/common/helpers/api-helper";
export const getDashboardDetails = createAsyncThunk('dashboard/get', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await dashboardApi.getDashboardDetails();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
